module.exports = __webpack_public_path__ + "elephant-fren-7561ce069a5a55b86ebc8789728b8fbc.png";